const CUSTOMER_STATUS = Object.freeze({
    "ACTIVE": 'ACT',
    "CREATED": 'CRE',
    "INACTIVE": 'INA',
    "PENDING": 'PAC'
  });
  
  export default Object.freeze({
      STATUS: CUSTOMER_STATUS
  });